// What the page tells the app chrome: its title, and whether that title is on
// screen. On a phone the top bar shows the title only once the page's own large
// title has scrolled away (the native large-title pattern).
import { create } from "zustand";

interface ChromeState {
  title: string | null;
  titleOnScreen: boolean;
  setTitle: (title: string | null) => void;
  setTitleOnScreen: (v: boolean) => void;
}

export const useChrome = create<ChromeState>((set) => ({
  title: null,
  titleOnScreen: false,
  setTitle: (title) => set({ title }),
  setTitleOnScreen: (titleOnScreen) => set({ titleOnScreen }),
}));
